<template>
  <v-card max-width="400" align="left" fill-height>
    <a :href="service.url" target="_blank">
      <v-img :src="require(`@/assets/${image}`)" max-height="169"></v-img>
    </a>
    <v-card-title :class="'darken-2 white--text mb-4 ' + color + ' darken-3'">
      <a
        :href="service.url"
        class="white--text"
        style="text-decoration: none"
        target="_blank"
      >{{ service.name }}</a>&nbsp;
    </v-card-title>
    <v-card-text>
      <p class="text-subtitle-2" v-text="service.description" />
      <div :class="'text--darken-3 ' + color + '--text'">Starting at</div>
      <a :href="service.url" style="text-decoration: none" target="_blank">
        <h5 :class="'text-h5 text--darken-3 ' + color + '--text'">
          <strong>${{ service.price_new || service.price }}</strong>/mo.
        </h5>
      </a>
      <div class="mt-4" v-if="expand && additionalOffers && additionalOffers.length">
        <v-btn icon @click="expand = false" :color="color + ' darken-3'">
          <v-icon :color="color + ' darken-3'" class="icon-right">mdi-chevron-up</v-icon>
        </v-btn>
        <div v-for="offer in additionalOffers" :key="offer.id">
          <div :class="'text-h6 text--darken-3 ' + color + '--text mt-2'">
            <a
              :href="offer.url"
              :class="'text--darken-3 ' + color + '--text'"
              style="text-decoration: none"
              target="_blank"
            >{{ offer.name }}</a>
          </div>
          <div>{{ offer.description }}</div>
          <div :class="'text-subtitle-1 text--darken-3 ' + color + '--text'">
            Starting at
            <a
              :href="offer.url"
              :class="'text--darken-3 ' + color + '--text'"
              style="text-decoration: none"
              target="_blank"
            >
              <strong>${{ offer.price_new }}/mo.</strong>
            </a>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <div v-if="additionalOffers && additionalOffers.length && !expand">
        <v-btn text @click="expand = true" :color="color + ' darken-3'">
          See more offers
          <v-icon :color="color + ' darken-3'" class="icon-right">mdi-chevron-down</v-icon>
        </v-btn>
      </div>
      <v-spacer />
      <v-btn text :href="service.url" target="_blank" :color="color + ' darken-3'">
        Learn more
        <v-icon :color="color + '--text darken-3'" class="icon-right">mdi-launch</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ServiceCard",

  props: ["business", "service", "serviceOffers"],

  data: () => ({
    expand: false
  }),

  methods: {},
  computed: {
    color() {
      switch (this.service.service_type) {
        case "phone":
          return "green";
        case "internet":
          return "blue";
        case "tv":
          return "orange";
        case "managed_wifi":
          return "blue";
        case "hbo_max":
          return "purple";
        default:
          return "blue";
      }
    },
    image() {
      switch (this.service.service_type) {
        case "phone":
          var image = "phone-card-header.jpg";
          if (this.service.business) {
            return "business-" + image;
          }
          return image;
        case "internet":
          image = "internet-card-header.jpg";
          if (this.service.business) {
            return "business-" + image;
          }
          return image;
        case "tv":
          return "tvnow-card-header.jpg";
        case "managed_wifi":
          return "managed-wifi-card-header.jpg";
        case "hbo_max":
          return "hbo-max-card-header.jpg";
        default:
          return "internet-card-header.jpg";
      }
    },
    additionalOffers() {
      if (this.serviceOffers) {
        switch (this.service.service_type) {
          case "internet":
            return this.serviceOffers.filter(x => {
              return (
                x.service_type === "internet" &&
                x.id !== this.service.id &&
                x.name !== "DSL Internet" &&
                x.name !== "DSL Internet for Business" &&
                this.business == x.business
              );
            });
          // case "tv":
          //   return this.serviceOffers.filter(x => {
          //     return x.id !== this.service.id && x.service_type === "tv";
          //   });
          default:
            return null;
        }
      }
      return null;
    },
    additionalOfferPriceRange() {
      if (this.additionalOffers && this.additionalOffers.length) {
        let min = this.additionalOffers.reduce(function(prev, curr) {
          return prev.price_new < curr.price_new ? prev : curr;
        });
        let max = this.additionalOffers.reduce(function(prev, curr) {
          return prev.price_new > curr.price_new ? prev : curr;
        });

        return [min, max];
      }
      return null;
    }
  }
};
</script>
